import { render, staticRenderFns } from "./WizardEnd.vue?vue&type=template&id=86f63e62"
import script from "./WizardEnd.vue?vue&type=script&lang=ts"
export * from "./WizardEnd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports